import { dangerColor, primaryColor } from 'assets/jss/material-dashboard-pro-react';
const plansServicesStyle = (theme) => ({
	lineContainer: {
		display: 'flex',
		marginBottom: 3,
		[theme.breakpoints.down('sm')]: {
			flexDirection: 'column',
		},
	},
	summary: {
		marginBottom: 16,
		display: 'flex',

		[theme.breakpoints.down('sm')]: {
			paddingLeft: 0,
		},
	},
	summaryContainer: {
		flex: 1,
	},
	hiddenButton: {
		visibility: 'hidden',
	},
	line: {
		flex: 1,
		[theme.breakpoints.down('sm')]: {
			width: '100%',
		},
	},
	addButton: {
		paddingLeft: 16,
		display: 'flex',
		marginBottom: '20px',
		alignItems: 'end',
		[theme.breakpoints.down('sm')]: {
			padding: 0,
			display: 'inline-block',
		},
	},
	removeLine: {
		color: dangerColor[0],
	},
	subtitle: {
		marginBottom: 24,
	},
	buildPlan: {
		color: `${primaryColor[0]} !important`
	},
	removePlan: {
		color: `${dangerColor[0]} !important`
	}
});

export default plansServicesStyle;
